import React from 'react';
export function Footer() {
  return <footer className="bg-black text-zinc-400 py-12 border-t border-violet-900/40" data-id="element-125">
      <div className="container mx-auto px-4 text-center max-w-2xl" data-id="element-126">
        <h4 className="text-white font-bold text-xl mb-4" data-id="element-127">
          🤝 MEGAPACK INFORMES DOCENTES 2026™
        </h4>

        <p className="mb-6 text-sm leading-relaxed" data-id="element-128">
          El sistema pedagógico N°1 de informes, actas y planificaciones para
          docentes argentinos. Diseñado para quien quiere documentar su trabajo
          con criterio real, comunicarse con las familias con profesionalismo y
          gestionar su año escolar como un docente de alto rendimiento.
          <br data-id="element-129" />
          <strong className="text-zinc-300 mt-2 block" data-id="element-130">
            Porque llegar al cierre de notas sin estrés no debería depender de
            si "sale la inspiración" o de si un colega te presta sus frases a
            último momento.
          </strong>
        </p>

        <div className="flex flex-wrap justify-center gap-4 text-sm mb-8" data-id="element-131">
          <a href="mailto:packcentral23@gmail.com" className="hover:text-violet-400 transition-colors" data-id="element-132">
            📧 packcentral23@gmail.com
          </a>
          <span className="hidden sm:inline" data-id="element-133">·</span>
          <span className="hover:text-violet-400 transition-colors" data-id="element-134">
            📱 @centralpack.ar
          </span>
          <span className="hidden sm:inline" data-id="element-135">·</span>
          <span className="hover:text-violet-400 transition-colors" data-id="element-136">
            🌐 www.informesdocentes.store
          </span>
        </div>

        <div className="text-xs text-zinc-600 border-t border-zinc-800 pt-8 space-y-3" data-id="element-137">
          <p data-id="element-138">
            © MEGAPACK INFORMES DOCENTES 2026™ — Todos los derechos
            reservados. Prohibida la reproducción y redistribución sin
            autorización expresa.
          </p>
          <p className="text-zinc-500" data-id="element-139">
            ⚠️ Este es un producto educativo con fines pedagógicos. El material
            está diseñado como guía y referencia profesional. Cada docente es
            responsable de adaptar el contenido a la normativa específica de su
            jurisdicción y a las características individuales de sus alumnos.
          </p>
          <p className="italic text-violet-300/80" data-id="element-140">
            🎓🇦🇷 "El próximo trimestre, vas a saber exactamente qué escribir en
            cada boletín y por qué."
          </p>
        </div>
      </div>
    </footer>;
}